import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step10 } from '../../../../shared/models/component-messages/blocCommun/simp/step10';
import { TypeMotsClef } from '../../../common/models/TypeMotsClef';
@Component({
  selector: 'app-type-mots-clef',
  templateUrl: './type-mots-clef.component.html'
})
export class TypeMotsClefComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeMotsClef';
  @Input() parentForm: FormGroup;
  @Input() disabled: boolean;
  @Input() motsClef: TypeMotsClef;

  public step10 = new Step10();

  constructor() {}

  public ngOnInit() {}

  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

}

